import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Settings = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "Settings (Coming Soon) | Atrable"

  return (
    <div style={{ minHeight: "calc(100vh + 30px)", textAlign: "center" }}>
      <h1
        style={{
          marginTop: "calc(35vh - 15px)",
        }}
      >
        Coming soon
      </h1>
      <Link to="/feedback">
        <button
          style={{
            textDecoration: "underline",
            padding: "15px",
            width: "calc(90% + 30px)",
            maxWidth: "750px",
            minWidth: "100px",
            borderRadius: "15px",
            border: "none",
            backgroundColor: "white",
            color: "#1877f3",
            marginTop: "7.5px",
            marginBottom: "60px",
            cursor: "pointer",
            fontSize: 20,
          }}
        >
          What feature do you want?
        </button>
      </Link>
    </div>
  );
};

export default Settings;
